import AbsComponent from '../common/AbsComponent';
import MoviePlayer from '../common/MoviePlayer';

class LayerTribute extends AbsComponent{
    constructor(_store){
        super('LayerTribute', _store, '#layer-tribute');

        this.vid = {
            mobile: {
                url: 'https://vod.plaync.com/lineageM/INTRO2.mp4',
                width: 300, height: 200
            }, 
            tablet: {
                url: 'https://vod.plaync.com/lineageM/INTRO2.mp4',
                width: 300, height: 200
            }, 
            pc: {
                url: 'https://vod.plaync.com/lineageM/INTRO2.mp4',
                width: 1920, height: 1080
            }
        }[ this.store.getState().config.device ];

        this.moviepath = this.store.getState().config.moviePath;
        this.closeBtn = $(this.el + ' .layer-btn-close').show();
        this.soundBtn = $(this.el + ' .layer-btn-sound').css({'margin-left': '80px'});

        this.video = new MoviePlayer( {
            url: this.vid.url,
            parentNode: $(this.el + ' .layer-container'),
            movieW: 300, movieH: 200,
            selector: 'layertribute', 
            videoControl: 'preload="auto" playsinline muted="muted" controlslist="nodownload"',
            styleOption: '',
            isBgType: false,
            stateCallback: (state)=> {
                if (state==='ended') {
                    if(!this.store.getState().secCookiesIsFull){
                        this.closeBtn.trigger('click');
                    }
                }
            }
        });

        // this.video.node.hide();
        // this.video.pause(0);

        this.addEvents();
    }

    addEvents(){
        this.soundBtn.on('click', e=>{
            this.video.muteToggle();
            this.soundBtn.toggleClass('is-sound', !this.video.isMute());
        });
    }

    open(){
        if (this.store.getState().secCookies.banquetIntro) {
            this.video.node.attr({controls:'controls'})
        }
        this.video.node.show();
        this.video.play(0);
        $(window).trigger('resize');

        this.store.dispatch( this.actions.addSecCookies( 'banquetIntro' ));
    }
    
    close(){
        this.video.pause(0);
        // this.video.node.hide();
    }

} // end of class
export default LayerTribute;